import { render, staticRenderFns } from "./PolicyReview.vue?vue&type=template&id=57b69112"
import script from "./PolicyReview.vue?vue&type=script&lang=js"
export * from "./PolicyReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports